import { render, staticRenderFns } from "./AdminProductsView.vue?vue&type=template&id=3ffc03bf"
import script from "./AdminProductsView.vue?vue&type=script&lang=ts"
export * from "./AdminProductsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports